// *=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=: -->
// Al ser renderizado se comportaría como una sub-instancia o como el componente principal. 
/**
 *      culguraG.js
 *          Script de culturaG.vue
 */

/* ======================================================================================================== */    
/* Importación de componentes instalados como dependencias o creados */
import Vue          from 'vue';
    import JsonExcel from 'vue-json-excel'
        Vue.component('downloadExcel', JsonExcel)

    import VueChartkick from 'vue-chartkick'
        Vue.use(VueChartkick)

import M from 'materialize-css'

import moment           from 'moment'    
import formulario       from './culturaGforma.vue'
import listado          from './culturaGlistado.vue'

import ingreso          from './ingreso.vue'
// import firebase         from 'firebase'
import {store}          from './../store/store'    

// import { ModelSelect } from 'vue-search-select'

/* ======================================================================================================== */    
/* exporta todo el código necesario para ser usado en su correspondiente <template> */
export default {

    name: 'culturaG',
    components:{
        'formulario':   formulario,     
        'listado':      listado,   
        'input-date':   ingreso,
        'moment':       moment,
    },        
    data: function() {
        return {

            // caso: {},                       // Objeto que tendrá información vacía (nuevo caso) o heredará uno de la lista

            /** Definiciones para EXPORTACION a CVS */
            json_fields: {
                'Nombre':               'nombre',
            },
            json_meta: [
                [{
                    'key': 'charset',
                    'value': 'iso-8859-1'
                    // 'value': 'utf-8'
                }]
            ],       
            
            referencias: "",
        } // return
    }, // data    
    mounted() {

        /** Definiciones para el uso de los TABS */
        var elem = document.querySelectorAll('.tabs'); 
        var instances = M.Tabs.init(elem, {});

        this.$refs.testt2.focus();
    }, // mounted()
}


// WEBPACK FOOTER //
// ./src/components/culturaG.js